import { apiClient } from './client';

export const login = (email: string, password: string) =>
  apiClient.post<{ accessToken: string; refreshToken: string }>('/api/auth/login', { email, password }).then(r => r.data);

export const loginWithMicrosoft = (idToken: string) =>
  apiClient.post<{ accessToken: string; refreshToken: string }>('/api/auth/microsoft', { idToken }).then(r => r.data);

export const refreshTokens = (refreshToken: string) =>
  apiClient.post<{ accessToken: string; refreshToken: string }>('/api/auth/refresh', { refreshToken }).then(r => r.data);

export const setup = (email: string, password: string, setupKey: string) =>
  apiClient.post<void>('/api/setup', { email, password, setupKey }).then(r => r.data);
